import Link from '@tiptap/extension-link';
import Placeholder from '@tiptap/extension-placeholder';
import { EditorContent, useEditor, UseEditorOptions } from '@tiptap/react';
import StarterKit from '@tiptap/starter-kit';
import { useEffect } from 'react';
import { IInputProps } from 'types/components/inputs/input.interface';
import InputWrapper from '../wrapper/InputWrapper';
import './InputTextEditor.scss';

export interface IInputTextEditorProps extends Omit<IInputProps, 'children'> {
  editorOptions?: UseEditorOptions;
  disabled?: boolean;
  placeholder?: string;
  hideEditors?: boolean;
  value?: string;
}

const InputTextEditor = ({
  editorOptions,
  value = '',
  placeholder,
  ...props
}: IInputTextEditorProps) => {
  const editor = useEditor({
    extensions: [
      StarterKit,
      Placeholder.configure({
        placeholder: placeholder ? ({ node }) => placeholder : undefined,
        emptyEditorClass: 'placeholder-text',
      }),
      Link.configure({
        openOnClick: false,
        autolink: false,
        linkOnPaste: false,
        HTMLAttributes: {
          rel: 'noopener noreferrer',
          target: '_blank',
        },
      }),
    ],
    ...editorOptions,
  });

  useEffect(() => {
    if (editor && editor.isEmpty && value) {
      editor.commands.setContent(value);
    }
    if (editor && !value) {
      editor.commands.setContent(' ');
    }
  }, [editor, value]);

  return (
    <InputWrapper
      {...props}
      value={value}
      placeholder={placeholder}
      render={props => (
        <EditorContent className='editor-input' editor={editor} />
      )}
    />
  );
};

export default InputTextEditor;
